import React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";

import { VendorState, PlaylistsMap } from "../../models";
import { getPlaylistsMap } from "../../selectors";

export interface InjectedPlaylistsMapProps {
    playlistsMap: PlaylistsMap;
}

const mapStateToProps = (state: VendorState) => ({
    playlistsMap: getPlaylistsMap(state),
});

export const withPlaylistsMap = <P extends InjectedPlaylistsMapProps>(
    WrappedComponent: ComponentType<P>,
) => {
    const ComponenWithPlaylists = (props: P) => (
        <WrappedComponent {...props} />
    );
    return connect(mapStateToProps)(ComponenWithPlaylists);
};
